import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Button, ErrorText, Field, Panel } from "../../components/ui";
import { totpDisable, totpEnable, totpSetup } from "./api";
import { useAuth } from "./AuthProvider";

export function TotpPage() {
  const { user, refreshUser } = useAuth();
  const [uri, setUri] = useState<string | null>(null);
  const [secret, setSecret] = useState<string | null>(null);
  const [code, setCode] = useState("");
  const [error, setError] = useState<unknown>(null);
  const [msg, setMsg] = useState<string | null>(null);

  async function start() {
    setError(null);
    setMsg(null);
    try {
      const r = await totpSetup();
      setUri(r.otpauthUri);
      setSecret(r.secret);
    } catch (e) {
      setError(e);
    }
  }

  async function enable() {
    setError(null);
    try {
      await totpEnable(code.trim());
      setUri(null);
      setSecret(null);
      setCode("");
      setMsg("2FA activé.");
      await refreshUser();
    } catch (e) {
      setError(e);
    }
  }

  async function disable() {
    setError(null);
    try {
      await totpDisable(code.trim());
      setCode("");
      setMsg("2FA désactivé.");
      await refreshUser();
    } catch (e) {
      setError(e);
    }
  }

  return (
    <Panel title="Sécurité — Double authentification">
      <p className="muted">
        État : <strong>{user?.totpEnabled ? "activée" : "désactivée"}</strong>
      </p>
      <ErrorText error={error} />
      {msg && <p className="ok-text">{msg}</p>}

      {!user?.totpEnabled && !uri && <Button onClick={start}>Configurer le 2FA</Button>}

      {uri && (
        <div className="totp-setup">
          <QRCodeSVG value={uri} size={168} />
          <p className="muted">
            Scannez le QR code, ou saisissez la clé : <code>{secret}</code>
          </p>
          <Field
            label="Code de vérification"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <Button onClick={enable}>Activer</Button>
        </div>
      )}

      {user?.totpEnabled && (
        <div className="totp-setup">
          <Field
            label="Code actuel pour désactiver"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <Button variant="danger" onClick={disable}>
            Désactiver le 2FA
          </Button>
        </div>
      )}
    </Panel>
  );
}
